import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { HttpService } from '../../services/http.service';
import { ConstantsService } from '../../constants/constants.service';
import { IdleService } from '../../services/idle.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ToastrModule, RouterLink],
  providers: [HttpService],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  user: any = {};
  formSubmitted: boolean = false;
  formSubmitLoader: boolean = false;
  loginForm!: FormGroup;
  forgotPasswordForm!: FormGroup;
  showForgotPassword: boolean = false;
  showPassword: boolean = false;
  showPrivacyPolicy: boolean = false;

  constructor(
    private httpService: HttpService,
    public constants: ConstantsService,
    private router: Router,
    private formBuilder: FormBuilder,
    private el: ElementRef,
    private toastr: ToastrService,
    private idleService: IdleService
  ) { }

  ngOnInit(): void {
    const storage = this.constants.getSession();
    if (storage) {
      this.router.navigate(['/dashboard']);
    }

    this.loginForm = this.formBuilder.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(this.constants.VALIDATION_PATTERNS['EMAIL']),
        ],
      ],
      password: ['', Validators.required],
    });

    this.forgotPasswordForm = this.formBuilder.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(this.constants.VALIDATION_PATTERNS['EMAIL']),
        ],
      ],
    });
  }

  login() {
  this.formSubmitted = true;
  if (this.loginForm.invalid) {
    return;
  }

  this.formSubmitLoader = true;
  const data = this.loginForm.value;

  this.httpService.postRequest(this.constants.SERVER_URLS['LOGIN'], data).subscribe(
    (res: any) => {
      this.formSubmitLoader = false;

      if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
        this.user = res.result;

        // Save session without checking roles
        this.constants.setSession(this.user);

        // Navigate directly to dashboard
        this.router.navigate(['/subscription']);
        this.idleService.resetIdleWatch();
        this.toastr.success('Logged in successfully.');
      } else {
        this.toastr.error(res.message || 'Login failed', 'Error');
      }
    },
    () => (this.formSubmitLoader = false)
  );
}

  

  showForgotPasswordForm() {
    this.showForgotPassword = !this.showForgotPassword;
  }

  resetPassword() {
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    const data = this.forgotPasswordForm.value;
    this.httpService
      .postRequest(this.constants.SERVER_URLS['RESET_PASSWORD'], data)
      .subscribe(
        (res: any) => {
          if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
            this.toastr.success('Password reset link sent!', 'Success');
            this.showForgotPassword = false;
          } else {
            this.toastr.error(res.message, 'Error');
          }
        },
        (err) => {
          this.toastr.error(
            'An error occurred. Please try again later.',
            'Error'
          );
        }
      );
  }

  openPrivacyModal() {
    this.showPrivacyPolicy = true;
  }

  closePrivacyModal() {
    this.showPrivacyPolicy = false;
  }

}
